import { useCallback } from 'react';
import { useIonToast } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

/** Returns a function that shows a red, dismissible error toast above the app footer. */
export const useErrorToast = () => {
  const [presentToast] = useIonToast();

  return useCallback(
    (message: string) => {
      presentToast({
        message,
        duration: 3000,
        position: 'bottom',
        positionAnchor: 'app-footer',
        cssClass: 'toast-danger',
        buttons: [{ icon: closeOutline, role: 'cancel' }],
      });
    },
    [presentToast]
  );
};
